import React, { useState, useEffect } from 'react';
import { Box, Grid } from '@mui/material';

import { ButtonUI, DialogUI } from '../../Interface';
import AlertMessagesTable from './AlertMessagesTable';
import AlertMessage from './AlertMessage';
import alertMessageService from '../../../service/Alert/alertMessage.service';

const AlertPanelDialog = (props) => {
  const { open, onClose } = props;

  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [refetchTable, setRefetchTable] = useState(false);

  const label = `Figyelmeztetések`;

  useEffect(() => {
    if (Object.keys(selectedValues).length > 0) {
      if (!selectedValues.recipients[0].readAt) {
        alertMessageService.markMessageAsRead({ recipientId: selectedValues.recipients[0].id }).finally(() => {
          setRefetchTable(true);
        });
      }
    }
  }, [selectedValues]);

  const handleClose = () => {
    setSelectedValues({});
    onClose();
  };

  return (
    <DialogUI open={open} onClose={handleClose} headerContent={label} maxWidth="xl" fullWidth>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {Object.keys(selectedValues).length === 0 ? (
            <AlertMessagesTable
              rowSelection={{ rowSelectionModel, setRowSelectionModel }}
              selectedValuesState={{ selectedValues, setSelectedValues }}
              refetchState={{ refetchTable, setRefetchTable }}
            />
          ) : (
            <AlertMessage selectedValuesState={{ selectedValues, setSelectedValues }} />
          )}
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="center" gap="0.5rem" mt="1rem">
        {Object.keys(selectedValues).length > 0 && (
          <ButtonUI text="Vissza" className="bg-success" onClick={() => setSelectedValues({})} />
        )}
        <ButtonUI text="Bezár" className="bg-primary" onClick={handleClose} />
      </Box>
    </DialogUI>
  );
};

export default AlertPanelDialog;
